<template>
  <div class="real-time-page">
    <div ref="realTimeDropdownRef" class="dropdown">
      <van-sticky>
        <van-dropdown-menu active-color="#337ECC">
          <van-dropdown-item
            v-model="groupValue"
            :options="groupOptions"
            @change="onGroupChange"
          />
          <van-dropdown-item
            v-model="stageValue"
            :options="stageOptions"
            @change="onStageChange"
          />
        </van-dropdown-menu>
      </van-sticky>
    </div>
    <div
      v-if="filtersReady && !isGroupStage && roundOptions.length"
      class="round-tabs"
    >
      <div
        v-for="item in roundOptions"
        :key="item.round"
        class="round-tab"
        :class="{ active: item.round === roundValue }"
        @click="onRoundChange(item.round)"
      >
        {{ item.name }}
      </div>
    </div>
    <div v-if="filtersReady" class="table-box">
      <div v-if="isGroupStage">
        <MyTable v-for="item in list" :key="item.id" :info="item" :sportType="sportType" :match="match" />
      </div>
      <div v-else>
        <GameList v-for="item in games" :key="item.id" :info="item" :unitType="unitType" />
      </div>
    </div>
    <div class="guide-mask" v-if="showGuide" @click="hideGuide">
      <img src="https://images.snsports.cn/FiA12FIJXQoFoF1B9im2hsSai6-2" />
    </div>
  </div>
</template>

<script>
import {
  getBMMatchList2,
  getBMStageGamesByBMMatchId,
  getBMGamesGroupByMatchId,
  getBMGamesByMatchId,
  getBMUnionMatch
} from '@/api/match'
import Vue from 'vue'
import { DropdownMenu, DropdownItem, Sticky } from 'vant'
Vue.use(DropdownMenu).use(DropdownItem).use(Sticky)
import MyTable from './components/my-table'
import GameList from './components/game-list'

function mapGameListItem(item) {
  if (!item || typeof item !== 'object') return null
  const homeTeam = item.homeTeam && typeof item.homeTeam === 'object' ? item.homeTeam : null
  const awayTeam = item.awayTeam && typeof item.awayTeam === 'object' ? item.awayTeam : null
  return {
    ...item,
    id: item.id,
    homeTeamName: item.homeTeamName || item.homeName || (homeTeam && homeTeam.name) || '',
    awayTeamName: item.awayTeamName || item.awayName || (awayTeam && awayTeam.name) || '',
    umFieldName: item.umFieldName || item.fieldName || item.courtName || item.location || '',
    groupName: item.groupName || item.group || '',
    roundDescription: item.roundDescription || item.roundName || '',
    isGroupGame: item.isGroupGame != null ? item.isGroupGame : 0,
    round: item.round
  }
}
export default {
  name: 'NewMatchDetailRealTime',
  components: {
    MyTable,
    GameList
  },
  data() {
    return {
      unionMatchId: '',
      groupValue: '',
      groupOptions: [],
      stageValue: '',
      stageOptions: [],
      stagesRaw: [],
      groupList: [],
      roundOptions: [],
      roundValue: '',
      list: [],
      games: [],
      showGuide: false,
      sportType: '',
      match: {},
      ruleType: '',
      filtersReady: false
    }
  },
  computed: {
    currentGroup() {
      return this.groupList.find(item => String(item.id) === String(this.groupValue))
    },
    unitType() {
      return this.currentGroup && this.currentGroup.unitType
    },
    isGroupStage() {
      if (this.ruleType === '淘汰赛') return false
      if (['循环赛', '双循环'].includes(this.ruleType)) return true
      return true
    }
  },
  mounted() {
    this.unionMatchId = this.$route.params.unionMatchId
    this.sportType = this.$route.query.sportType || ''
    if (this.unionMatchId) {
      if (!this.sportType) {
        this.fetchSportType()
      }
      this.loadGroups()
    }
    this.checkGuide()
  },
  activated() {
    const savedIdx = window.localStorage.getItem('realTimeIndex')
    if (savedIdx != null && this.groupList.length) {
      const idx = Number(savedIdx)
      const group = this.groupList[idx]
      if (group && String(group.id) !== String(this.groupValue)) {
        this.groupValue = group.id
        this.loadStages()
      }
    }
  },
  methods: {
    fetchSportType() {
      getBMUnionMatch({ unionMatchId: this.unionMatchId }).then(res => {
        if (res && res.data && res.data.match) {
          this.sportType = res.data.match.sportType || ''
        }
      })
    },
    loadGroups() {
      getBMMatchList2({ unionMatchId: this.unionMatchId }).then(res => {
        const list = (res && res.data && res.data.list) || []
        this.groupList = list
        this.groupOptions = list.map(item => ({
          text: item.group,
          value: item.id
        }))
        if (!list.length) {
          this.groupValue = ''
          this.stageOptions = []
          this.stageValue = ''
          this.roundOptions = []
          this.roundValue = ''
          this.filtersReady = true
          return
        }
        const savedIdx = window.localStorage.getItem('realTimeIndex')
        const idx = savedIdx != null ? Number(savedIdx) : 0
        const group = list[idx] || list[0]
        this.groupValue = group.id
        this.loadStages()
      }).catch(() => {
        this.groupOptions = []
        this.groupValue = ''
        this.filtersReady = true
      })
    },
    loadStages() {
      this.stageOptions = []
      this.stageValue = ''
      this.stagesRaw = []
      this.roundOptions = []
      this.roundValue = ''
      this.filtersReady = false
      if (!this.groupValue) {
        this.filtersReady = true
        return
      }

      getBMStageGamesByBMMatchId({
        unionMatchId: this.unionMatchId,
        matchId: this.groupValue
      }).then(res => {
        const data = (res && res.data) || {}
        this.match = data.match || {}
        if (!this.sportType && this.match.sportType) {
          this.sportType = this.match.sportType
        }

        const stages = data.stages || []
        this.stagesRaw = stages
        this.stageOptions = stages.map(s => ({
          text: s.stageName != null ? s.stageName : String(s.id),
          value: s.id
        }))
        if (stages.length > 0) {
          this.stageValue = stages[0].id
        }
        this.filtersReady = true
        this.$nextTick(() => {
          this.syncRuleTypeFromStage()
          this.refreshByRuleType()
        })
      }).catch(() => {
        this.stageOptions = []
        this.filtersReady = true
        this.$nextTick(() => {
          this.syncRuleTypeFromStage()
          this.refreshByRuleType()
        })
      })
    },
    onGroupChange() {
      const idx = this.groupList.findIndex(item => String(item.id) === String(this.groupValue))
      if (idx >= 0) {
        window.localStorage.setItem('realTimeIndex', idx)
      }
      this.loadStages()
    },
    onStageChange() {
      this.syncRuleTypeFromStage()
      this.refreshByRuleType()
    },
    onRoundChange(round) {
      if (round === this.roundValue) return
      this.roundValue = round
      this.fetchKnockoutGames()
    },
    syncRuleTypeFromStage() {
      const stages = this.stagesRaw || []
      if (stages.length === 0) {
        this.ruleType = (this.match && this.match.ruleType) || ''
        return
      }
      const st = stages.find(s => String(s.id) === String(this.stageValue))
      this.ruleType = (st && st.ruleType) || (this.match && this.match.ruleType) || ''
    },
    buildKnockoutRounds() {
      if (this.ruleType !== '淘汰赛') {
        this.roundOptions = []
        this.roundValue = ''
        return
      }
      const stage = this.stagesRaw.find(s => String(s.id) === String(this.stageValue))
      if (!stage) {
        this.roundOptions = []
        this.roundValue = ''
        return
      }
      const rounds = []
      const roundCount = stage.roundCount || 0
      for (let i = 1; i <= roundCount; i++) {
        let name = `第${i}轮`
        if (Array.isArray(stage.roundAliasList)) {
          const aliasItem = stage.roundAliasList.find(a => a.round === i)
          if (aliasItem && aliasItem.alias) {
            name = aliasItem.alias
          }
        }
        rounds.push({ name, round: i })
      }
      this.roundOptions = rounds
      this.roundValue = rounds.length ? rounds[0].round : ''
    },
    refreshByRuleType() {
      this.list = []
      this.games = []
      if (!this.groupValue || this.stageValue === '') return

      if (this.ruleType === '淘汰赛') {
        this.buildKnockoutRounds()
        this.fetchKnockoutGames()
      } else {
        this.roundOptions = []
        this.roundValue = ''
        this.fetchGroupStageTable()
      }
    },
    fetchGroupStageTable() {
      getBMGamesGroupByMatchId({
        matchId: this.groupValue,
        stageId: this.stageValue
      }).then(res => {
        const { data } = res
        this.list = data.list || []
        this.match = data.match || this.match
      }).catch(() => {
        this.list = []
      })
    },
    fetchKnockoutGames() {
      if (!this.roundValue) {
        this.games = []
        return
      }
      getBMGamesByMatchId({
        matchId: this.groupValue,
        stageId: this.stageValue,
        round: this.roundValue
      }).then(res => {
        const list = (res && res.data && res.data.list) || []
        this.games = list.map(mapGameListItem).filter(Boolean)
      }).catch(() => {
        this.games = []
      })
    },
    checkGuide() {
      const hasShown = localStorage.getItem('realTimeGuideShown')
      if (!hasShown) {
        this.showGuide = true
      }
    },
    hideGuide() {
      this.showGuide = false
      localStorage.setItem('realTimeGuideShown', 'true')
    }
  }
}
</script>

<style scoped lang="scss">
.real-time-page {
  min-height: 100vh;
  box-sizing: border-box;
  background: #fff;
  padding: 12px 16px 24px;
}

.round-tabs {
  margin-top: 12px;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  white-space: nowrap;
  display: flex;

  .round-tab:not(:last-child) {
    margin-right: 10px;
  }

  &::-webkit-scrollbar {
    display: none;
  }

  scrollbar-width: none;
  -ms-overflow-style: none;

  .round-tab {
    min-width: 72px;
    padding: 6px 12px;
    text-align: center;
    border-radius: 4px;
    font-size: 14px;
    color: #337ECC;
    background: #ECF5FF;
    box-sizing: border-box;
    cursor: pointer;
    user-select: none;
    flex-shrink: 0;

    &.active {
      background: #337ECC;
      color: #FFFFFF;
    }
  }
}

.table-box {
  margin-top: 12px;
  margin-left: -4px;
}

.guide-mask {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.7);
  z-index: 999;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 94%;
    height: auto;
    max-width: 375px;
  }
}
</style>

<style lang="scss">
.van-sticky--fixed {
  padding: 12px 16px;
  background-color: #fff;
}

.real-time-page {
  .van-dropdown-menu__bar {
    background-color: #ffffff;

    .van-dropdown-menu__item + .van-dropdown-menu__item {
      margin-left: 12px;
    }
    box-shadow: none;
  }

  .van-dropdown-menu__item {
    min-width: 0;
    justify-content: flex-start;
    border-radius: 5px;
    background-color: #f4f4f5;
  }

  .van-dropdown-menu__title {
    flex: 1;
    width: 100%;
    min-width: 0;
    max-width: 100%;
    display: flex;
    align-items: center;
    box-sizing: border-box;
    padding-right: 24px;

    .van-ellipsis {
      text-align: center;
      flex: 1;
      min-width: 0;
    }
  }

  .van-dropdown-menu__title::after {
    right: 10px;
    margin-top: -6px;
    border: 4px solid;
    border-color: transparent transparent #686b6f #686b6f;
  }

  .van-dropdown-menu__title--down::after {
    margin-top: -2px;
  }

  .van-dropdown-menu__title--active::after {
    border-color: transparent transparent currentColor currentColor !important;
  }
}
</style>
